import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=13a78c28&scoped=true&"
import script from "./Guide.vue?vue&type=script&lang=js&"
export * from "./Guide.vue?vue&type=script&lang=js&"
import style0 from "./Guide.vue?vue&type=style&index=0&id=13a78c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a78c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a78c28')) {
      api.createRecord('13a78c28', component.options)
    } else {
      api.reload('13a78c28', component.options)
    }
    module.hot.accept("./Guide.vue?vue&type=template&id=13a78c28&scoped=true&", function () {
      api.rerender('13a78c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/Guide.vue"
export default component.exports